

(function (window) {

    var customDropdown = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_FULL_TEXT = 'collapsed';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$seletButton = $('.js-vca-dropdown-button');
            ui.$list = $('.js-vca-dropdown-list');
            ui.$listItem = $('.js-vca-dropdown-list li a');
            ui.$coveoSeletButton = $('.js-vca-coveo-dropdown-button');
            ui.$coveoList = $('.js-vca-coveo-dropdown-list');
            ui.$coveoListItem = $('.js-vca-coveo-dropdown-list div');
        }

        function openDropdown(e) {
            e.preventDefault();
            if (this.getAttribute("aria-expanded") === 'true') {
                hideListbox(this);
                return;
            }
            var $button = this;
            var $list = $(this).next(".js-vca-dropdown-list");
            $list.removeClass('hidden');
            $button.setAttribute('aria-expanded', 'true');
            $list.trigger('focus');
        }

        function itemSelected(e) {
            var item;
            if (this === undefined) {
                item = e.parent();
            } else {
                item = $(this).parent();
            }
            let parent = $(item).closest('.js-vca-dropdown-list');
            if(!parent.hasClass('js-link-list')){
                e.preventDefault();
            }
            $(item).siblings().removeClass('focused selected');
            $(item).addClass('focused selected');
            updateSelectValue($(item));
            hideListbox($(item).closest('.js-vca-dropdown-list'));
        }

        function updateSelectValue(e) {
            var item = e;
            var itemText = $(item).find('a').html();
            var itemValue = $(item).attr('data-value');
            var input = $(item).closest('.vca-dropdown-select').find('.js-vca-dropdown-input');
            var button = $(item).closest('.vca-dropdown-select').find('.js-vca-dropdown-button');
            input.val(itemValue).trigger('change');
            $(button).html(itemText)
            input.trigger('keypress');
        }

        function checkShow(e) {
            e.preventDefault();
            var key = e.which || e.keyCode;

            var first = $(this).find('.focused').is(':first-child');
            var last = $(this).find('.focused').is(':last-child');

            switch (key) {
                case 40:  //down arrow
                    if (!last) {
                        $(this).find('.focused').removeClass('focused').next().addClass('focused');
                    }
                    e.stopPropagation();
                    break;
                case 38:  // up arrow
                    if (!first) {
                        $(this).find('.focused').removeClass('focused').prev().addClass('focused');
                    }
                    e.stopPropagation();
                    break;
                case 27:  // esc
                case 9:   // tab
                    hideListbox($(this));
                    e.stopPropagation();
                    break;
                case 32:  // space bar
                case 13:  // enter key
                    $(this).find('.focused').addClass('selected');
                    $(this).find('.focused a').trigger('click');
                    updateSelectValue($(this).find('.focused'));
                    hideListbox($(this));
                    e.stopPropagation();
                    break;
            }
        }

        function hideListbox(e) {
            var item;

            if (this === undefined) {
                item = e;
            } else {
                item = $(e);
            }

            var parent = $(item).closest('.vca-dropdown-select');
            var list = $(parent).find('.js-vca-dropdown-list');
            var button = $(parent).find(".js-vca-dropdown-button");
            list.addClass('hidden');
            button.attr('aria-expanded', 'false');
        }

        function openCoveoDropdown(e) {
            e.preventDefault();
            if (this.getAttribute("aria-expanded") === 'true') {
                hideCoveoListbox(this);
                return;
            }
            var $button = this;
            var $list = $(this).next(".js-vca-coveo-dropdown-list");
            $list.removeClass('hidden');
            $button.setAttribute('aria-expanded', 'true');
            $list.trigger('focus');
        }

        function itemSelectedCoveo(e) {
            var item;
            if (this === undefined) {
                item = e;
            } else {
                item = $(this);
            }
            // console.log(item);
            // console.log(e);

            let selectedElement = $(item).find('.CoveoSort');
            let caption = $(selectedElement).data('caption');
            $('.js-vca-coveo-dropdown-button').html(`Sort By: ${caption}`);

            $(item).siblings().removeClass('focused selected');
            $(item).addClass('focused selected');
            hideCoveoListbox($(item).closest('.js-vca-coveo-dropdown-list'));
        }

        function hideCoveoListbox(e) {
            var item;

            if (this === undefined) {
                item = e;
            } else {
                item = $(e);
            }

            var parent = $(item).closest('.vca-dropdown-select');
            var list = $(parent).find('.js-vca-coveo-dropdown-list');
            var button = $(parent).find(".js-vca-coveo-dropdown-button");
            list.addClass('hidden');
            button.attr('aria-expanded', 'false');
        }


        function bindEvents() {
            ui.$seletButton.on('click', openDropdown);
            ui.$listItem.on('click', itemSelected);
            //ui.$list.on('blur', hideListbox);
            ui.$list.bind('keydown', checkShow);
            if ($('.js-vca-coveo-dropdown-button').length > 0) {
                ui.$coveoSeletButton.on('click', openCoveoDropdown);
                ui.$coveoListItem.on('click', itemSelectedCoveo);
            }
        }

        function init() {
            cacheUI();
            bindEvents();
        }

        return {
            init: init
        };
    };

    var select = customDropdown();
    select.init();


})(window);
